import { render, staticRenderFns } from "./TxProductAspectRatio.vue?vue&type=template&id=2fd61f81&scoped=true&"
import script from "./TxProductAspectRatio.vue?vue&type=script&lang=js&"
export * from "./TxProductAspectRatio.vue?vue&type=script&lang=js&"
import style0 from "./TxProductAspectRatio.vue?vue&type=style&index=0&id=2fd61f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd61f81",
  null
  
)

export default component.exports